// src/types/aviator.ts
var AviatorPhase = /* @__PURE__ */ ((AviatorPhase2) => {
  AviatorPhase2["WAITING"] = "WAITING";
  AviatorPhase2["BETTING"] = "BETTING";
  AviatorPhase2["FLYING"] = "FLYING";
  AviatorPhase2["ENDED"] = "ENDED";
  return AviatorPhase2;
})(AviatorPhase || {});

// src/types/game-round.ts
var GameRoundPhase = /* @__PURE__ */ ((GameRoundPhase2) => {
  GameRoundPhase2["WAITING"] = "WAITING";
  GameRoundPhase2["BETTING"] = "BETTING";
  GameRoundPhase2["ROLLING"] = "ROLLING";
  return GameRoundPhase2;
})(GameRoundPhase || {});
export {
  AviatorPhase,
  GameRoundPhase
};
//# sourceMappingURL=index.js.map